import { DEFAULT_STORE_OBJECT } from '@/redux/constants';
import type { DefaultStoreObject } from '@/redux/types';
import { generateUUIDv4 } from '@/utils/number';
import type { ProcurementZone } from '@/views/screens/Procurement';
import ProcurementZoneType from './ProcurementZoneTypes';
import zoneListPayload from './requestPayload/PostBindZoneList';

export interface ProcurementZoneState extends Record<string, any> {
  zoneList: DefaultStoreObject<ProcurementZone[]> & {
    totalRecord: number;
  };
  setAddNewZoneData: {
    btnClicked: boolean;
  };
  checkedSelectedZone: boolean;
}

const initialState: ProcurementZoneState = {
  zoneList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    totalRecord: 0,
  },
  zoneListReq: {
    ...zoneListPayload,
  },
  setAddNewZoneData: {
    btnClicked: false,
  },

  checkedSelectedZone: false,
};

// biome-ignore lint/style/useDefaultParameterLast: <explanation>
const ProcurementZoneReducer = (state = initialState, { type, payload }: any): ProcurementZoneState => {
  switch (type) {
    case ProcurementZoneType.UPDATE_ZONE_LOCATION_LIST: {
      const list = [...(state.zoneList.data || [])];
      if (payload.type === 'updateZone') {
        list.forEach((element) => {
          if (element.regionId === payload.values.regionId) {
            element.locations = payload.values.locations;
          }
        });
      } else {
        list.forEach((element) => {
          if (element.regionId === payload.zoneId) {
            element.locations = element.locations.filter((Item) => Item.locationId !== payload.locationId);
          }
        });
      }

      return {
        ...state,
        zoneList: {
          ...state.zoneList,
          data: list,
        },
      };
    }

    /** Procurement route config zone search list reducer start */
    case ProcurementZoneType.GET_PROCUREMENT_ZONE_LIST: {
      return {
        ...state,
        zoneList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.zoneList,
          progressing: true,
        },
      };
    }

    case ProcurementZoneType.GET_PROCUREMENT_ZONE_LIST_SUCCESS: {
      // @ts-ignore
      payload?.data?.data.forEach((element) => {
        element.renderKey = generateUUIDv4();
        element.isNew = false;
        element.checked = state.checkedSelectedZone;
      });
      return {
        ...state,
        zoneList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.zoneList,
          success: true,
          data: [...(state.zoneList.data || []), ...payload.data.data],
          progressing: false,
          totalRecord: payload.data.total,
        },
      };
    }

    case ProcurementZoneType.GET_PROCUREMENT_ZONE_LIST_FAIL: {
      return {
        ...state,
        zoneList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.zoneList,
          error: true,
          progressing: false,
          totalRecord: 0,
        },
      };
    }

    case ProcurementZoneType.RESET_PROCUREMENT_ZONE_LIST: {
      return {
        ...state,
        zoneList: {
          ...state.zoneList,
          data: [],
        },
      };
    }

    case ProcurementZoneType.SET_PROCUREMENT_ZONE_LIST_REQUEST: {
      if (payload === 'removeNewRecords') {
        state.zoneList?.data?.shift();
        return {
          ...state,
          setAddNewZoneData: {
            btnClicked: false,
          },
          checkedSelectedZone: false,
          zoneList: {
            ...state.zoneList,
            data: state.zoneList?.data,
          },
        };
      }
      if (payload === 'reset') {
        return {
          ...state,
          setAddNewZoneData: {
            btnClicked: false,
          },
          checkedSelectedZone: false,
          zoneListReq: {
            ...zoneListPayload,
          },
          zoneList: {
            ...state.zoneList,
            data: [],
            // state.zoneList?.data?.[0]?.isNew === true
            //   ? [state.zoneList.data[0]]
            //   : [],
          },
        };
      }
      return {
        ...state,
        zoneListReq: {
          ...state.zoneListReq,
          ...payload,
        },
      };
    }

    case ProcurementZoneType.SET_ACTIVE_ZONE_ITEM: {
      return {
        ...state,
        activeZone: {
          data: payload,
        },
      };
    }

    case ProcurementZoneType.RESET_ACTIVE_ZONE_ITEM: {
      return {
        ...state,
        activeZone: {
          data: {},
        },
      };
    }

    /** Procurement route config zone search list reducer end */

    case ProcurementZoneType.SET_ADD_NEW_ZONE: {
      let stateValue = {
        ...state,
        setAddNewZoneData: {
          btnClicked: payload.btnClicked,
        },
      };
      if (payload?.add === true) {
        stateValue = {
          ...stateValue,
          zoneList: {
            ...state.zoneList,
            // @ts-ignore
            data: [{ isNew: true, renderKey: generateUUIDv4() }, ...(state.zoneList.data || [])],
          },
        };
      }
      if (payload?.remove === true) {
        const removeItem = state.zoneList.data?.slice(1);
        stateValue = {
          ...stateValue,
          zoneList: {
            ...state.zoneList,
            data: [...(removeItem || [])],
          },
        };
      }
      return stateValue;
    }

    default:
      return state;
  }
};

export default ProcurementZoneReducer;
